import { usePlatformStore } from '@/entities/platform'
import axios from 'axios'

const api = axios.create({
  baseURL: 'https://customer.api.delever.uz',
  timeout: 10000,
  headers: {
    Shipper: process.env.NEXT_PUBLIC_SHIPPER_ID,
    Platform: process.env.NEXT_PUBLIC_PLATFORM_ID,
    Authorization:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3Njg0NzcwNjAsImlzcyI6ImFnZ3JlZ2F0b3Itc2hpcHBlciIsInNoaXBwZXJfaWQiOiI4Y2Q0YzEwNy1jZDk3LTRiMDktYmExOC1iYWVmY2EwNmI5ZjciLCJ1c2VyX3R5cGVfaWQiOiJiYjYwM2U5ZS00OWEzLTQ3OGItOWUxMC1jNzg0MmY5YzY3NmYiLCJzdWIiOiI4Y2Q0YzEwNy1jZDk3LTRiMDktYmExOC1iYWVmY2EwNmI5ZjcifQ.bje56cY-G21sQkosm4sH_Z0QuvNgSz4Eeai-dF6Iudk',
  },
})

api.interceptors.request.use((config) => {
  const { params } = usePlatformStore.getState()
  const token =
    params?.token ||
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3Njg0NzcwNjAsImlzcyI6ImFnZ3JlZ2F0b3Itc2hpcHBlciIsInNoaXBwZXJfaWQiOiI4Y2Q0YzEwNy1jZDk3LTRiMDktYmExOC1iYWVmY2EwNmI5ZjciLCJ1c2VyX3R5cGVfaWQiOiJiYjYwM2U5ZS00OWEzLTQ3OGItOWUxMC1jNzg0MmY5YzY3NmYiLCJzdWIiOiI4Y2Q0YzEwNy1jZDk3LTRiMDktYmExOC1iYWVmY2EwNmI5ZjcifQ.bje56cY-G21sQkosm4sH_Z0QuvNgSz4Eeai-dF6Iudk'

  if (token) {
    config.headers.Authorization = token
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error)
  },
)

export default api
